import { render, staticRenderFns } from "./highlighted-textarea.vue?vue&type=template&id=693ebbd3&"
import script from "./highlighted-textarea.vue?vue&type=script&lang=ts&"
export * from "./highlighted-textarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports